import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost, httpPostCore, httpPutCore } from '../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';
import {fetchRole} from '../role';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addUserStatus: null,
  deleteUserStatus: null,
  addUserData: {},
  dropDownData: {},
  passwordStatus: null,
  allUserEmailsAndNames: [],
  isNotesLoading: false,
  notesSuccessMsg: null,
  addSystemNotesStatus: null,
  reactiveStatus: null,
};

const slice = createSlice({
  name: 'addUser',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNotesStart: (state) => {
      state.isNotesLoading = true;
      state.errorMsg = null;
    },
    postUserData: (state, action) => {
      state.addUserStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    putUserData: (state, action) => {
      state.putUserStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response ? action?.payload?.response : 'User updated successfully';
    },
    postSystemNotesData: (state, action)=>{
      state.addSystemNotesStatus =action.payload.status;
      state.isNotesLoading=false;
      state.errorMsg =null;
      state.notesSuccessMsg=action.payload.response;
    },
    getAddUserData: (state, action) => {
      state.addUserData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addUserStatus = action.payload.status;
      state.successMsg = action.payload.message;
    },
    deleteUser: (state, action) => {
      state.deleteUserStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    reactiveUser: (state, action) => {
      state.reactiveStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetSystemNotesData: (state) => {
      state.isNotesLoading = false;
      state.addSystemNotesStatus = null;
      state.notesSuccessMsg = null;
      state.errorMsg = null;
    },
    changePassword: (state, action) => {
      state.isLoading = false;
      state.successMsg = action?.payload?.response;
      state.passwordStatus = action?.payload?.status;
    },
    getAllUserEmailAndNames: (state, action) => {
      state.allUserEmailsAndNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ?
        action?.payload?.data?.message :
        action?.payload?.data?.error;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.addUserStatus = null;
      state.putUserStatus = null;
      state.isLoading = false;
      state.passwordStatus = null;
    },
    resetMessage: (state, action) => {
      state.deleteUserStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetReactiveMessage: (state, action) => {
      state.reactiveStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addUserStatus = null;
      state.addUserData = null;
      state.putUserData = null;
      state.deleteUserStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  fetchSuccess,
  fetchError,
  resetMessage,
  resetStatus,
  resetData,
  postUserData,
  putUserData,
  getAddUserData,
  getRoleData,
  deleteUser,
  changePassword,
  getAllUserEmailAndNames,
  fetchNotesStart,
  postSystemNotesData,
  resetSystemNotesData,
  reactiveUser,
  resetReactiveMessage,
} = slice.actions;

export const postAddUserData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPostCore(`users/create`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 500 || data?.data?.status === 400 ) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postUserData(data));
          dispatch(fetchRole());
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postEditUserData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPutCore(`users`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 500 || data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(putUserData(data));
          dispatch(fetchRole());
        }
      })
      .catch((error) => {
        console.error('Error al realizar la solicitud PUT:', error); // Registro del error
        dispatch(fetchError(error.message));
      });
  };
};

export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNotesStart());
    httpPost(`save/usernotes`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAddUserData = (Id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`get/user/${Id}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getAddUserData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const deleteUserData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`delete/user/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteUser(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const reactiveUserData = (userid) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reactivate/user/${userid}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(reactiveUser(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postChangePassword = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`admin/change/user/password`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(changePassword(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchAllUserEmailsAndNames = (data) => {
  return (dispatch) => {
    httpGet(`get/all/usernameandemailid`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllUserEmailAndNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const resetReactivMessage = () => {
  return (dispatch) => {
    dispatch(resetReactiveMessage());
  };
};
export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};
export const ResetData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
